import { useEffect } from 'react';

import * as Sentry from '@sentry/react';

const useSentryInit = (): void => {
  useEffect(() => {
    const isSentryDisabled = (): boolean => {
      const { hostname } = window.location;

      return hostname === 'localhost';
    };

    if (isSentryDisabled()) return;

    Sentry.init({
      dsn: 'https://3d83551eaf210daf2d7b045d4af274b3@sentry.sys.liis.dev/12',
      environment: 'production',
      tracesSampleRate: 1.0,
    });
  }, []);
};

export default useSentryInit;
